import { IEnumeration } from 'utility-js-enumeration';
declare var Enumeration: IEnumeration;
export function NotificationSettingEnum(contactInformationModel: any, accountModel: any) {
  const Settings = {
    PUSH: {
      label: 'Push Notifications',
      contact: 'cell phone',
      hasContactInformation() {
        return true;
      },
      getContactInformation() {
        return false;
      },
      getDisplayContactInformation() {
        return false;
      },
      isVerified() {
        return true;
      },
      isPrepared() {
        return true;
      }
    },

    TEXT: {
      label: 'Text Messages',
      contact: 'phone number',
      hasContactInformation() {
        return !_.isEmpty(contactInformationModel.getPhoneNumber());
      },
      getContactInformation() {
        return contactInformationModel.getPhoneNumber();
      },
      getDisplayContactInformation() {
        return contactInformationModel.getDisplayPhoneNumber();
      },
      isVerified() {
        return contactInformationModel.isVerifiedPhoneNumber();
      },
      isPrepared() {
        return contactInformationModel.hasPreparedNumber();
      }
    },

    EMAIL: {
      label: 'Email',
      contact: 'email address',
      hasContactInformation() {
        return !_.isEmpty(accountModel.email);
      },
      getContactInformation() {
        return accountModel.email;
      },
      getDisplayContactInformation() {
        return accountModel.email;
      },
      isVerified() {
        return !_.isEmpty(accountModel.email);
      },
      isPrepared() {
        return contactInformationModel.hasPreparedNumber();
      }
    }
  };

  return Enumeration.useDefinitionAsEnum(Settings);
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-notification-settings/src/types/notification_setings_enum.ts